import { defineComponent as s, computed as c } from "vue";
import { getConfig as d } from "./component-library2.js";
const r = /* @__PURE__ */ s({
  __name: "square-badge",
  props: {
    text: null,
    footnoteText: { default: void 0 },
    footnoteClass: { default: void 0 },
    theme: { default: void 0 },
    clickBadge: { type: Function, default: void 0 }
  },
  emits: ["click"],
  setup(a, { emit: o }) {
    const t = a, l = c(() => {
      const e = [];
      return t.theme && e.push(`square-badge--${t.theme}`), t.footnoteText && e.push("square-badge--button"), e;
    }), n = () => {
      const e = d().globalModal || void 0;
      e?.openModal && e.openModal({
        content: t.footnoteText,
        className: t.footnoteClass
      });
    };
    return { __sfc: !0, props: t, emit: o, className: l, openModal: n, handleClick: (e) => {
      t.footnoteText ? (e.preventDefault(), n()) : t.clickBadge ? (e.preventDefault(), t.clickBadge(e)) : o("click", e);
    } };
  }
});
export {
  r as default
};
